const KEY = 'bbc.theme';
export type Theme = 'dark' | 'light';

export function getTheme(): Theme {
  try { return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark'; } catch { return 'dark'; }
}

export function setTheme(t: Theme) {
  try { localStorage.setItem(KEY, t); } catch {}
  document.documentElement.classList.toggle('light', t === 'light');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', t === 'light' ? '#f4f5f7' : '#0a0c10');
}
